module.exports = __webpack_public_path__ + "media/Rossa - Terlalu Cinta (Saxophone Cover by Dori Wirawan).1f42ea6d.mp3";